import React from 'react';
import '../Go/Go.css';
import { Link } from 'react-router-dom';

const Go = () => {
  return (
    <div className="go-container">
      <div className="go-left">
        <h1>Let’s Discuss Your Legal Needs</h1>
        <p>We value professionalism, discretion, and trust in every client relationship. Your privacy and confidentiality are our top priorities—both for you and those you represent.</p>
      </div>
      <div className="go-right">
      <Link to="/contactus">
        <button className="contact-btn-go">Contact Now</button>
        </Link>
      </div>
    </div>
  );
};

export default Go;
